import dayjs from 'dayjs'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Java's Date.toString(): "Sat Oct 03 20:00:00 EDT 2026"
const JAVA_DATE = /^\w{3} (\w{3}) (\d{2}) (\d{2}):\d{2}:\d{2} .+ (\d{4})$/

/**
 * The calendar day a sponsor chose in the mobile app, from the startDate/endDate query parameter the app
 * puts on the /donate-mobile URL. Returned as a local-midnight dayjs for that day.
 *
 * Each app encodes the day differently, and old app versions stay installed for months, so every format
 * is decoded here rather than trusting `dayjs(value)` (which read them in the browser's time zone and
 * landed 1 day early for iOS and 2 for Android on US phones):
 * - "YYYY-MM-DD": used as is.
 * - iOS "2026-10-05T00:00:00Z": local wall-clock time labelled Z, so the date part is the chosen day.
 * - Android Date.toString() of `LocalDate.atStartOfDay(UTC)`: the string shows that UTC midnight in the
 *   phone's zone — the previous evening west of UTC (hour >= 12), the same morning east of it. Undo that.
 *   For 'day'/'weekly', the app also built the LocalDate from the picker's UTC-midnight millis in the
 *   phone's zone, which west of UTC is one day earlier still.
 */
export function parseAppSponsorDate(value: string | null, donationType: string | null) {
  if (!value) return undefined

  const plain = value.match(/^(\d{4}-\d{2}-\d{2})(T|$)/)
  if (plain) return dayjs(plain[1])

  const java = value.match(JAVA_DATE)
  if (java) {
    const [, monthName, day, hour, year] = java
    const month = MONTHS.indexOf(monthName)
    if (month < 0) return undefined
    const westOfUtc = Number(hour) >= 12
    const pickerShift = westOfUtc && (donationType === 'day' || donationType === 'weekly') ? 1 : 0
    return dayjs(new Date(Number(year), month, Number(day))).add((westOfUtc ? 1 : 0) + pickerShift, 'day')
  }

  const parsed = dayjs(value)
  return parsed.isValid() ? parsed : undefined
}
